import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { VARIATION_GROUPS } from "@/data/products";
import { ShopCard } from "@/components/ShopCard";
import { Reveal } from "@/components/Reveal";

export default function Shop() {
  const { hash } = useLocation();
  const [highlight, setHighlight] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!hash) return undefined;
    const id = hash.slice(1);
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -90 });
        else el.scrollIntoView({ behavior: "smooth", block: "center" });
        setHighlight(id);
        setTimeout(() => setHighlight(""), 2600);
      }
    }, 450);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main data-testid="shop-page" className="bg-[#FFF4D6] min-h-screen">
      <section className="relative grain bg-[#E5A910] pt-16 pb-20 overflow-hidden">
        <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
          <p className="text-xs font-black uppercase tracking-[0.25em] text-[#594519] mb-5">The shop</p>
          <h1 className="font-display font-extrabold tracking-[-0.04em] leading-[0.9] text-6xl md:text-8xl">
            <span className="block overflow-hidden">
              <motion.span className="block" initial={{ y: "105%" }} animate={{ y: 0 }} transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}>
                Pick your <span className="font-serif-i">pour.</span>
              </motion.span>
            </span>
          </h1>
          <p className="mt-6 max-w-md text-[#2B2008]">Every variation of our watermelon, pineapple and apple juices. Mix in ginger, mint, lemon or kale on any bottle.</p>
        </div>
        <motion.img
          src="/img/fruit_pineapple.webp"
          alt=""
          aria-hidden="true"
          initial={{ y: 80, rotate: 20, opacity: 0 }}
          animate={{ y: 0, rotate: 12, opacity: 1 }}
          transition={{ type: "spring", stiffness: 60, damping: 12, delay: 0.2 }}
          className="hidden sm:block absolute right-[6%] -bottom-16 w-40 md:w-56"
        />
      </section>
      <section className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 md:py-20 space-y-16">
        {VARIATION_GROUPS.map((g) => (
          <div key={g.base} data-testid={`shop-group-${g.base.toLowerCase()}`}>
            <Reveal className="flex items-center gap-4 mb-6">
              <img src={g.img} alt="" aria-hidden="true" className="h-10 w-10 object-contain" />
              <h2 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight">{g.base}</h2>
              <span className="flex-1 border-t border-[#181203]/15" />
            </Reveal>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {g.items.map((v, i) => (
                <Reveal key={v.id} delay={(i % 3) * 0.08}>
                  <div
                    id={`item-${v.id}`}
                    data-testid={`shop-item-${v.id}`}
                    className={`rounded-[2rem] transition-shadow duration-500 ${highlight === v.id ? "ring-4 ring-[#B5122F] shadow-[0_0_40px_rgba(181,18,47,0.35)]" : ""}`}
                  >
                    <ShopCard v={{ ...v, img: g.img }} />
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        ))}
      </section>
    </main>
  );
}
